


















import { snakeCase } from 'lodash'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../../../Pi/types'
import { PropertyActionType } from '../../../../logic/Actions/PropertyAction/types'
import { ActionTypes } from '../../../../logic/Actions/types'

@Component({
  data() {
    return {
      snakeCase,
      ActionTypes,
    }
  }
})
export default class PropertyActionSelectAction extends UseFields {
  @Prop() action!: PropertyActionType

  @Prop() currentProperty!: any

  @Prop() disabled!: boolean

  @Prop() getAvailableActionTypes!: () => Array<PropertyActionType>

  get actionsOptions(): Array<SelectOptionData> {
    return this.getAvailableActionTypes().map((type) => ({
      label: this.$t(`flow_actions_${ type.toLowerCase() }_action`).toString(),
      value: type
    }))
  }

  setActionHandler(arg: FieldData): FieldData {
    arg.setter = (val) => this.setActionType(val)
    return arg
  }

  @Emit()
  setActionType(type: PropertyActionType): PropertyActionType {
    return type
  }
}
